// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7775) return "css/Template2.601c5b59-f347-4bc4-864e-323e278c61f2.chunk.css";
	if (chunkId === 628) return "css/Template3.601c5b59-f347-4bc4-864e-323e278c61f2.chunk.css";
	if (chunkId === 9245) return "css/MobileTemplate1.601c5b59-f347-4bc4-864e-323e278c61f2.chunk.css";
	if (chunkId === 7866) return "css/aiAgent.601c5b59-f347-4bc4-864e-323e278c61f2.chunk.css";
	if (chunkId === 1399) return "packages/reactflow@11.8.3/reactflow.601c5b59-f347-4bc4-864e-323e278c61f2.bundle.css";
	if (chunkId === 4149) return "packages/@wangeditor@5.0.1/@wangeditor.601c5b59-f347-4bc4-864e-323e278c61f2.bundle.css";
	if (chunkId === 3339) return "packages/icp-mining@1.0.9999-SNAPSHOT/icp-mining.601c5b59-f347-4bc4-864e-323e278c61f2.bundle.css";
	if (chunkId === 8309) return "css/saas-ui-chat.601c5b59-f347-4bc4-864e-323e278c61f2.chunk.css";
	if (chunkId === 5299) return "packages/icp-form-designer@1.0.9999-SNAPSHOT/icp-form-designer.601c5b59-f347-4bc4-864e-323e278c61f2.bundle.css";
	// return url for filenames based on template
	return undefined;
};